module.exports = __webpack_public_path__ + "static/media/store-stop-and-shop.b0dfd703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-stop-and-shop.jpg
// module id = 224
// module chunks = 0